import React from 'react';

export default function AntoraSymbol({ size = 26 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" style={{ display: 'block', flexShrink: 0 }}>
      <defs>
        <linearGradient id="al-grad" x1="8" y1="8" x2="56" y2="56">
          <stop offset="0%" stopColor="#00D4FF"/>
          <stop offset="100%" stopColor="#7C3AED"/>
        </linearGradient>
        <radialGradient id="al-glow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#00D4FF" stopOpacity="0.8"/>
          <stop offset="100%" stopColor="#00D4FF" stopOpacity="0"/>
        </radialGradient>
      </defs>
      <path d="M32 2.5L57.5 17.25V46.75L32 61.5L6.5 46.75V17.25L32 2.5Z"
            stroke="url(#al-grad)" strokeWidth="1.6" strokeLinejoin="round" fill="none" opacity="0.4"/>
      <g stroke="url(#al-grad)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <path d="M16 48 L32 14"/>
        <path d="M48 48 L32 14"/>
        <path d="M22.5 36 L28 36"/>
        <path d="M36 36 L41.5 36"/>
      </g>
      <circle cx="32" cy="36" r="8" fill="url(#al-glow)" opacity="0.55"/>
      <circle cx="32" cy="36" r="3.5" fill="url(#al-grad)"/>
      <circle cx="32" cy="14" r="2.2" fill="url(#al-grad)"/>
      <circle cx="16" cy="48" r="2.2" fill="url(#al-grad)"/>
      <circle cx="48" cy="48" r="2.2" fill="url(#al-grad)"/>
    </svg>
  );
}
